module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900-13de59f1a36b6cb4bca0050160ff0e41.svg";